import React from "react";
import "../styles/TopNavbar.css";
import { logout } from "../services/AuthService";

const TopNavBar = () => {
  const handleLogout = () => {
    logout();
    window.location.href = "/";
  };

  const name = localStorage.getItem("user_name") || "User";
  const initial = (name.charAt(0) || "?").toUpperCase();

  return (
    <div className="top-section">
      <div className="admin-profile">
        <p className="link-text">
          <span className="top-navbar-avatar" aria-hidden="true">
            {initial}
          </span>
          Hi, {name}
        </p>
      </div>
      <button className="logout-button" onClick={handleLogout}>
        Sign Out
      </button>
    </div>
  );
};

export default TopNavBar;
